module.exports = __webpack_public_path__ + "img/app-store.33109a4c.png";